import React from 'react'

export function ErrorStatus({ errors }) {
    
  return (
    <>
        {errors.length > 0 && <div className="px-3 text-red-800 bg-red-200 py-3 mx-3 rounded-lg mb-4 animate__animated animate__bounceIn">
            {errors.map(err => {
                return <span key={errors.indexOf(err)} className="text-xs font-semibold flex gap-2">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
                        </svg>

                    </span>
                    <span>{err}</span>
                </span>
            })}
        </div>}
    </>
  )
}


export default function SuccessStatus({ showStatus, message }) {
  return (
    <>
        {showStatus && <div className="py-3 my-3 px-4 flex justify-start gap-3 items-center text-sm bg-green-200 rounded-lg animate__animated animate__bounceIn font-semibold">
            <span className="text-green-700">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                    <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                </svg>

            </span>
            <span>
                {message}
            </span>
        </div>}
    </>
  )
}
